// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "6944b9fc694b9c44" + ".css";
};